/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChannelKind } from './channelKind';
import { OtpAuthenticatorStatus } from './otpAuthenticatorStatus';

export interface OtpStatusResponse { 
    current_otp_active_until?: Date;
    request_otp_blocked_until?: Date;
    available_channels?: Array<ChannelKind>;
    authenticator_status?: OtpAuthenticatorStatus;
    verification_attempts_limit_reached: boolean;
}